var _rect, _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFreeFreeUnisex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 20,
    viewBox: "0 0 64 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_38_735",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#ED6F8D",
    stroke: "#ED6F8D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_38_735)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 63,
    height: 19,
    rx: 9.5,
    fill: "#AEB0BD",
    stroke: "#AEB0BD"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.7173 14V6.72727H28.3764V7.83168H25.0348V9.80611H28.0568V10.9105H25.0348V14H23.7173ZM29.4418 14V8.54545H30.6882V9.45455H30.745C30.8445 9.13968 31.0149 8.89702 31.2564 8.72656C31.5002 8.55374 31.7784 8.46733 32.0909 8.46733C32.1619 8.46733 32.2412 8.47088 32.3288 8.47798C32.4188 8.48272 32.4934 8.491 32.5526 8.50284V9.68537C32.4981 9.66643 32.4117 9.64986 32.2933 9.63565C32.1773 9.61908 32.0649 9.6108 31.956 9.6108C31.7216 9.6108 31.5109 9.66169 31.3239 9.76349C31.1392 9.86293 30.9936 10.0014 30.8871 10.179C30.7805 10.3565 30.7273 10.5613 30.7273 10.7933V14H29.4418ZM35.5968 14.1065C35.0499 14.1065 34.5776 13.9929 34.1799 13.7656C33.7845 13.536 33.4803 13.2116 33.2672 12.7926C33.0542 12.3712 32.9476 11.8752 32.9476 11.3047C32.9476 10.7436 33.0542 10.2512 33.2672 9.82741C33.4827 9.40128 33.7833 9.06984 34.1692 8.8331C34.5551 8.59399 35.0085 8.47443 35.5293 8.47443C35.8655 8.47443 36.1827 8.52888 36.481 8.63778C36.7817 8.74432 37.0468 8.91004 37.2765 9.13494C37.5085 9.35985 37.6908 9.64631 37.8233 9.99432C37.9559 10.34 38.0222 10.7519 38.0222 11.2301V11.6243H33.5513V10.7578H36.79C36.7876 10.5116 36.7343 10.2926 36.6301 10.1009C36.526 9.90672 36.3804 9.75402 36.1934 9.64276C36.0087 9.53149 35.7933 9.47585 35.5471 9.47585C35.2843 9.47585 35.0534 9.53977 34.8546 9.66761C34.6557 9.79309 34.5007 9.95881 34.3894 10.1648C34.2805 10.3684 34.2248 10.5921 34.2225 10.8359V11.5923C34.2225 11.9096 34.2805 12.1818 34.3965 12.4091C34.5125 12.634 34.6747 12.8068 34.883 12.9276C35.0913 13.0459 35.3352 13.1051 35.6145 13.1051C35.8016 13.1051 35.9708 13.0791 36.1223 13.027C36.2739 12.9725 36.4052 12.8932 36.5165 12.7891C36.6278 12.6849 36.7118 12.5559 36.7686 12.402L37.9689 12.5369C37.8932 12.8542 37.7488 13.1312 37.5357 13.3679C37.325 13.6023 37.0551 13.7846 36.726 13.9148C36.397 14.0426 36.0205 14.1065 35.5968 14.1065ZM39.1097 14V8.54545H40.3952V14H39.1097ZM39.756 7.77131C39.5524 7.77131 39.3772 7.70384 39.2305 7.56889C39.0837 7.43158 39.0103 7.26705 39.0103 7.07528C39.0103 6.88116 39.0837 6.71662 39.2305 6.58168C39.3772 6.44437 39.5524 6.37571 39.756 6.37571C39.962 6.37571 40.1372 6.44437 40.2816 6.58168C40.4284 6.71662 40.5018 6.88116 40.5018 7.07528C40.5018 7.26705 40.4284 7.43158 40.2816 7.56889C40.1372 7.70384 39.962 7.77131 39.756 7.77131Z",
    fill: "#090F23"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreeFreeUnisex);
export default __webpack_public_path__ + "static/media/free-free-unisex.a6d6006fcd46a3a4eaf8ad21bf4705de.svg";
export { ForwardRef as ReactComponent };